import SystemAnalysis from "../components/System-Analysis/SystemAnalysis";
import PipeAnalysis from "../components/Pipe-Analysis/PipeAnalysis";
import PSM from "../components/PSM/PSM";
import AmmoniaInventory from "../components/Ammonia-Inventory/AmmoniaInventory";
import NotificationTable from "../components/Tasks-Events/NotificationTable";

export const WIDGET_TYPES = {
  SYSTEM_ANALYSIS: "1000101",
  PIPE_ANALYSIS: "1000102",
  PSM: "1000103",
  AMMONIA_INVENTORY: "1000104",
  NOTIFICATION_TABLE: "1000105",
};

export const WIDGET_COMPONENTS = {
  [WIDGET_TYPES.SYSTEM_ANALYSIS]: SystemAnalysis,
  [WIDGET_TYPES.PIPE_ANALYSIS]: PipeAnalysis,
  [WIDGET_TYPES.PSM]: PSM,
  [WIDGET_TYPES.AMMONIA_INVENTORY]: AmmoniaInventory,
  [WIDGET_TYPES.NOTIFICATION_TABLE]: NotificationTable,
};

// Main widgets are all except notification table
export const MAIN_WIDGETS = Object.values(WIDGET_TYPES).filter(
  id => id !== WIDGET_TYPES.NOTIFICATION_TABLE
);


